'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

const ContactPageHeader = () => {
  const { t } = useLanguage();

  return (
    <div className="bg-gradient-to-br from-primary via-secondary to-primary text-white py-16 px-6">
      <div className="container mx-auto max-w-4xl text-center">
        <div className="flex items-center justify-center mb-6">
          <div className="flex items-center justify-center w-20 h-20 rounded-full bg-white/10 backdrop-blur-sm">
            <Icon name="ChatBubbleLeftRightIcon" size={40} />
          </div>
        </div>

        <h1 className="text-4xl md:text-5xl font-bold font-amiri mb-4">
          {t('تواصل معنا', 'Contact Us')}
        </h1>

        <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto leading-relaxed">
          {t(
            'نحن هنا للإجابة على استفساراتك ومساعدتك في الحصول على أفضل تجربة مع خدماتنا. تواصل معنا عبر أي من القنوات المتاحة.',
            'We are here to answer your inquiries and help you get the best experience with our services. Contact us through any of the available channels.'
          )}
        </p>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-8">
          <div className="flex items-center gap-2 text-white/90">
            <Icon name="ClockIcon" size={20} />
            <span className="text-sm">{t('استجابة سريعة', 'Quick Response')}</span>
          </div>
          <div className="flex items-center gap-2 text-white/90">
            <Icon name="UserGroupIcon" size={20} />
            <span className="text-sm">{t('فريق محترف', 'Professional Team')}</span>
          </div>
          <div className="flex items-center gap-2 text-white/90">
            <Icon name="CheckBadgeIcon" size={20} />
            <span className="text-sm">{t('دعم متواصل', 'Continuous Support')}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPageHeader;